import {chapterApiLanguage} from '../../utils/chapterLanguage';

const resourceUrl = (identifier, kind, language) => {
  const base = `${process.env.REACT_APP_LATAAMO_PROXY_SERVER}/api/event/${encodeURIComponent(identifier)}/vtt/${kind}`;
  return language ? `${base}/${encodeURIComponent(kind === 'chapter' ? chapterApiLanguage(language) : language)}` : base;
};

export const listVttResources = (identifier, kind) => fetch(resourceUrl(identifier, kind));

export const downloadVttResourceUrl = (identifier, kind, language) => resourceUrl(identifier, kind, language);

export const uploadVttResource = (identifier, kind, body, headers) => fetch(resourceUrl(identifier, kind), {
  method: 'POST',
  body,
  ...(headers && {headers})
});

export const removeVttResource = (identifier, kind, language) => fetch(resourceUrl(identifier, kind, language), {
  method: 'DELETE'
});